import { getEmailAvailableAccounts } from '../../../utils/email'
import { EMAIL_NEED_RECONNECT } from '../Email.constants'
import { getEmailAccountLabel } from '../Email.utils'

export function toEmailAccountSelectItem(item) {
  return {
    [EMAIL_NEED_RECONNECT]: item[EMAIL_NEED_RECONNECT],
    corporate: item.corporate,
    description: item.description,
    insert_signature_before_quoted_text:
      item.insert_signature_before_quoted_text,
    label: getEmailAccountLabel(item),
    signature: item.signature,
    value: item.id,
  }
}

export function toEmailAccountSelectItems(
  items,
  mapper = toEmailAccountSelectItem
) {
  return getEmailAvailableAccounts(items).map(mapper)
}
